<div class="ventas-container">
    <div class="header-actions">
      <h1>Historial de Ventas</h1>
    </div>

    <div class="filter-row">
      <span class="filter-label">Método de pago:</span>
      <mat-button-toggle-group [value]="metodoPagoSeleccionado" (change)="filtrarPorMetodoPago($event.value)">
        <mat-button-toggle *ngFor="let m of metodosPagoFiltro" [value]="m.value">
          {{ m.label }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

  <app-table-generic
    [config]="(tableConfig$ | async) || { columns: [] }"
    [data]="(data$ | async) || []"
    [totalItems]="(totalItems$ | async) || 0"
    [loading]="(loading$ | async) || false"
    [error]="error$ | async"
    [dialogComponent]="dialogComponent"
    [serverSide]="true"
    [pageIndexInput]="currentPage$.value"
    [pageSizeInput]="pageSize$.value"
    [canDelete]="isAdministrador"
    [canEdit]="false"
    (editClick)="onEdit($event)"
    (deleteClick)="onDelete($event)"
    (detailsClick)="onViewDetails($event)"
    (pageChange)="onPageChange($event)"
    (sortChange)="onSortChange($event)">
  </app-table-generic>
</div>
